type Coords = [number, number];

function toRadians(angleInDegrees: number) {
  return (angleInDegrees * Math.PI) / 180;
}

function toDegrees(angleInRadians: number) {
  return (angleInRadians * 180) / Math.PI;
}

function offset(c1: Coords, distance: number, bearing: number) {
  var lat1 = toRadians(c1[1]);
  var lon1 = toRadians(c1[0]);
  var dByR = distance / 6378137; // distance divided by 6378137 (radius of the earth) wgs84
  var lat = Math.asin(
    Math.sin(lat1) * Math.cos(dByR) +
      Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing)
  );
  var lon =
    lon1 +
    Math.atan2(
      Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1),
      Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat)
    );
  return [toDegrees(lon), toDegrees(lat)];
}

export default function circleToPolygon(
  center: Coords,
  radius: number,
  numberOfSegments: number
) {
  var n = numberOfSegments ? numberOfSegments : 32;
  var flatCoordinates: Coords[] = [];
  var coordinates = [];
  for (var i = 0; i < n; ++i) {
    flatCoordinates.push.apply(
      flatCoordinates,
      offset(center, radius, (2 * Math.PI * i) / n)
    );
  }
  flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);

  for (var ii = 0, j = 0; j < flatCoordinates.length; j += 2) {
    coordinates[ii++] = flatCoordinates.slice(j, j + 2);
  }

  return {
    type: 'Polygon',
    coordinates: [coordinates.reverse()]
  };
}



// WEBPACK FOOTER //
// ./src/utils/circleToPolygon.ts